import { ObserverBase } from "@share/web-conferences/signal-r/observers/ObserverBase";
import { SignalRMethod } from "@api/repositories/reatime-repository/types";
import { ObserverData } from "@share/web-conferences/interfaces/signalr/ObserverData";
import {
    CurrentPresentationUpdatedParam
} from "@share/web-conferences/interfaces/signalr/CurrentPresentationUpdatedParam";
import { WebConferenceService } from "@share/web-conferences/data/WebConferenceService";
import { isCurrentPresentationChanged } from "@share/web-conferences/helpers/slides/CurrentPresnetationComporator";
import { parseJson } from "@common/TypesHelper";

export class CurrentPresentationUpdatedObserver extends ObserverBase {
    method = SignalRMethod.webConferenceCurrenPresentationUpdated;

    constructor(
        protected readonly data: ObserverData,
        private readonly webConferenceService: WebConferenceService
    ) {
        super(data);
    }

    async callback(data: any): Promise<void> {
        const update = parseJson(data, {}) as CurrentPresentationUpdatedParam;
        if (this.webConferenceService.webConferenceData &&
            this.data.schemaId == update.schemaId &&
            this.data.objectId == update.objectId &&
            isCurrentPresentationChanged(update.currentPresentation, this.webConferenceService.webConferenceData.currentPresentation)
        ) {
            const previousPresentationType = this.webConferenceService.webConferenceData.currentPresentation?.type;
            const previousPresentationUserId = this.webConferenceService.webConferenceData.currentPresentation?.userId;

            this.webConferenceService.setCurrentPresentation(update.currentPresentation);
        }
    }
}
